export var PriceComponentType = /* @__PURE__ */ ((PriceComponentType2) => {
  PriceComponentType2["SESSION"] = "SESSION";
  PriceComponentType2["ENERGY"] = "ENERGY";
  PriceComponentType2["CHARGE_TIME"] = "CHARGE_TIME";
  PriceComponentType2["PARKING_TIME"] = "PARKING_TIME";
  PriceComponentType2["FLAT"] = "FLAT";
  PriceComponentType2["MARGIN"] = "MARGIN";
  PriceComponentType2["TOTAL"] = "TOTAL";
  return PriceComponentType2;
})(PriceComponentType || {});
export var SimulationOverallState = /* @__PURE__ */ ((SimulationOverallState2) => {
  SimulationOverallState2["AVAILABLE"] = "AVAILABLE";
  SimulationOverallState2["OCCUPIED"] = "OCCUPIED";
  SimulationOverallState2["FUNCTIONAL"] = "FUNCTIONAL";
  SimulationOverallState2["UNKNOWN_WITH_REAL_TIME"] = "UNKNOWN_WITH_REAL_TIME";
  SimulationOverallState2["UNKNOWN_WITHOUT_REAL_TIME"] = "UNKNOWN_WITHOUT_REAL_TIME";
  SimulationOverallState2["OUT_OF_ORDER_WITH_REAL_TIME"] = "OUT_OF_ORDER_WITH_REAL_TIME";
  SimulationOverallState2["OUT_OF_ORDER_WITHOUT_REAL_TIME"] = "OUT_OF_ORDER_WITHOUT_REAL_TIME";
  return SimulationOverallState2;
})(SimulationOverallState || {});
export var SimulationRealtimeState = /* @__PURE__ */ ((SimulationRealtimeState2) => {
  SimulationRealtimeState2["AVAILABLE"] = "AVAILABLE";
  SimulationRealtimeState2["UNAVAILABLE"] = "UNAVAILABLE";
  SimulationRealtimeState2["OUT_OF_ORDER"] = "OUT_OF_ORDER";
  SimulationRealtimeState2["FAULTED"] = "FAULTED";
  SimulationRealtimeState2["UNKNOWN"] = "UNKNOWN";
  return SimulationRealtimeState2;
})(SimulationRealtimeState || {});
